import { render, staticRenderFns } from "./TaskRankingLink.vue?vue&type=template&id=981ed2b8&scoped=true&"
import script from "./TaskRankingLink.vue?vue&type=script&lang=js&"
export * from "./TaskRankingLink.vue?vue&type=script&lang=js&"
import style0 from "./TaskRankingLink.vue?vue&type=style&index=0&id=981ed2b8&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "981ed2b8",
  null
  
)

export default component.exports